<template>

  <div>

    <b-card
      no-body
    >
      <b-card-body>
        <b-card-title>Pedido</b-card-title>
        <b-card-sub-title>Información suministrada por el odontólogo</b-card-sub-title>

        <div
          v-if="userData.role_id == 5 && planningOrder.is_paid && planningOrder.planning_pdf"
          class="mt-2"
        >
          <b-alert
            variant="info"
            show
          >
            <h4 class="alert-heading">
              Importante
            </h4>
            <div class="alert-body">
              <span>Por favor, ingresa y realiza un comentario para gestionar y aprobar la <b>Planificación (.pdf)</b>. Esto es indispensable para que podamos proceder con su fabricación.</span>
            </div>
          </b-alert>
        </div>

        <div
          v-if="!planningOrder.is_paid"
          class="mt-2"
        >
          <b-alert
            variant="warning"
            show
          >
            <div class="alert-body">
              <p>Recuerda que, para iniciar la planificación, primero se debe realizar el pago. Esto lo registra el usuario comercial.</p>

              <b-button
                v-if="[1, 2].includes(userData.role.id)"
                variant="success"
                class="mt-1"
                size="sm"
                @click="paymentModal = true"
              >Registrar pago</b-button>

            </div>

          </b-alert>
        </div>

        <div
          v-if="userData.role_id == 5 && !planningOrder.planning_pdf"
          class="mt-2"
        >
          <b-alert
            variant="primary"
            show
          >
            <div class="alert-body">
              <span>Aún no se ha diseñado la planificación. Estamos trabajando para entregarla lo antes posible.</span>
            </div>
          </b-alert>
        </div>

        <b-row class="mt-2">
          <b-col>
            <b-media
              class="mb-2"
              no-body
            >
              <b-media-aside class="mr-1">
                <b-avatar
                  rounded
                  variant="light-primary"
                  size="34"
                >
                  <feather-icon
                    icon="PaperclipIcon"
                    size="18"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h6 class="mb-0">
                  RX panorámica
                </h6>
                <small v-if="planningOrder.order.images">
                  <b-button
                    variant="link"
                    size="sm"
                    @click="viewDocument(planningOrder.order.images, 'RX panorámica', 'rx_panorama')"
                  >Ver panorámica</b-button>
                </small>
              </b-media-body>

            </b-media>
          </b-col>
          <b-col>
            <b-media
              class="mb-2"
              no-body
            >
              <b-media-aside class="mr-1">
                <b-avatar
                  rounded
                  variant="light-primary"
                  size="34"
                >
                  <feather-icon
                    icon="PaperclipIcon"
                    size="18"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h6 class="mb-0">
                  Fotos intraorales
                </h6>
                <small v-if="planningOrder.order.images">
                  <b-button
                    variant="link"
                    size="sm"
                    @click="viewDocument(planningOrder.order.images, 'Fotos intraorales', 'intraoral_photos')"
                  >Ver fotos intraorales</b-button>
                </small>
              </b-media-body>

            </b-media>
          </b-col>
          <b-col>
            <b-media
              class="mb-2"
              no-body
            >
              <b-media-aside class="mr-1">
                <b-avatar
                  rounded
                  variant="light-primary"
                  size="34"
                >
                  <feather-icon
                    icon="DownloadIcon"
                    size="18"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h6 class="mb-0">
                  Escaneo intraoral
                </h6>
                <small v-if="planningOrder.order.intraoral_scan_url">
                  <b-button
                    variant="link"
                    size="sm"
                    @click="viewDocument(planningOrder.order.intraoral_scan_full_url, 'Escaneo intraoral', 'download')"
                  >Descargar escaneo intraoral</b-button>
                </small>
              </b-media-body>

            </b-media>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="12"
            md="12"
            lg="6"
          >
            <b-alert
              variant="secondary"
              show
            >
              <h4 class="alert-heading">
                Hallazgos
              </h4>
              <div class="alert-body">
                <span>{{ planningOrder.order.findings }}</span>
              </div>
            </b-alert>
          </b-col>
          <b-col
            cols="12"
            md="12"
            lg="6"
          >
            <b-alert
              variant="secondary"
              show
            >
              <h4 class="alert-heading">
                Objetivos
              </h4>
              <div class="alert-body">
                <span>{{ planningOrder.order.objectives }}</span>
              </div>
            </b-alert>
          </b-col>
        </b-row>

        <hr class="mb-2">
        <b-card-title>Gestión planificador</b-card-title>
        <b-card-sub-title>Información gestionada por el planificador</b-card-sub-title>

        <div
          v-if="planningOrder.is_paid"
        >

          <b-media
            class="mt-2 mb-2"
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                :variant="planningOrder.planning_pdf ? 'light-primary' : 'light-secondary'"
                size="34"
              >
                <feather-icon
                  icon="PaperclipIcon"
                  size="18"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                Planificación (.pdf)
              </h6>
              <small v-if="planningOrder.planning_pdf">
                <b-button
                  variant="link"
                  size="sm"
                  @click="viewDocument(planningOrder.planning_pdf_full_url, 'Planificación (.pdf)', 'pdf')"
                >Ver planificación</b-button>
              </small>
              <p v-if="planningOrder.number_upper_aligners || planningOrder.number_lower_aligners">
                <b>Alineadores superiores: </b>{{ planningOrder.number_upper_aligners }} | <b>Alineadores inferiores: </b>{{ planningOrder.number_lower_aligners }}
                <!--              | <b>Plantillas de attachments: </b>{{ (planningOrder.number_upper_aligners > 0 && planningOrder.number_lower_aligners > 0) ? 2 : 1 }}-->
              </p>

              <div v-if="planningOrder.fabrications.length > 0">

                <hr class="mb-2">

                <!--              <small>Alineadores a fabricar</small>-->
                <div
                  v-for="(fabrication, index) in planningOrder.fabrications"
                  :key="index"
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <div>
                    <h6 class="text-muted font-weight-bolder">
                      Superiores
                    </h6>
                    <p class="mb-0">
                      {{ fabrication.upper_aligners }}
                    </p>
                  </div>
                  <div>
                    <h6 class="text-muted font-weight-bolder">
                      Inferiores
                    </h6>
                    <p class="mb-0">
                      {{ fabrication.lower_aligners }}
                    </p>
                  </div>
                  <div>
                    <h6 class="text-muted font-weight-bolder">
                      Estado
                    </h6>
                    <b-badge
                      class="profile-badge"
                      :variant="fabrication.is_fabricated ? 'light-primary' : 'light-warning'"
                    >
                      {{ fabrication.is_fabricated ? 'Fabricado' : 'Sin fabricar' }}
                    </b-badge>
                    <br>

                  </div>
                  <div>
                    <h6 class="text-muted font-weight-bolder">
                      Acciones
                    </h6>
                    <!--<b-button
                      v-if="!fabrication.is_paid"
                      variant="success"
                      class="float-right"
                      size="sm"
                      :to="{ name: 'admin-checkout-aligners', params: { id: planningOrder.id, fabrication: fabrication.id, payment_type: 'fabricacion' } }"
                    >
                      Ver detalle / Pagar
                    </b-button> -->

                    <b-badge
                      :variant="fabrication.is_paid ? 'light-success' : 'light-warning'"
                    >
                      <feather-icon
                        v-if="fabrication.is_paid"
                        icon="CheckIcon"
                        size="18"
                      />
                      {{ fabrication.is_paid ? 'Pago realizado' : 'Pago pendiente' }}
                    </b-badge>
                  </div>
                </div>
              </div>

            </b-media-body>

            <div v-if="[1, 3].includes(userData.role.id)">
              <b-button
                v-if="!planningOrder.planning_pdf"
                variant="info"
                class="float-right"
                size="sm"
                @click="uploadDataPlanning('planning_pdf')"
              >
                Editar / Agregar
              </b-button>
              <b-button
                v-else
                variant="danger"
                class="float-right"
                size="sm"
                @click="confirmDelete('planning_pdf')"
              >
                Eliminar
              </b-button>
            </div>

          </b-media>

          <b-media
            class="mb-2"
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                :variant="planningOrder.models ? 'light-primary' : 'light-secondary'"
                size="34"
              >
                <feather-icon
                  icon="DownloadIcon"
                  size="18"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                Modelos
              </h6>
              <small v-if="planningOrder.models">
                <b-button
                  variant="link"
                  size="sm"
                  @click="viewDocument(planningOrder.models_full_url, 'Modelos', 'download')"
                >Descargar modelos</b-button>
              </small>
            </b-media-body>

            <div v-if="[1, 3].includes(userData.role.id)">
              <b-button
                v-if="!planningOrder.models"
                variant="info"
                class="float-right"
                size="sm"
                @click="uploadDataPlanning('models')"
              >
                Editar / Agregar
              </b-button>
              <b-button
                v-else
                variant="danger"
                class="float-right"
                size="sm"
                @click="confirmDelete('models')"
              >
                Eliminar
              </b-button>
            </div>

          </b-media>

          <b-media
            class="mb-2"
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                :variant="planningOrder.model_3d_url ? 'light-primary' : 'light-secondary'"
                size="34"
              >
                <feather-icon
                  icon="LinkIcon"
                  size="18"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="mb-0">
                Plan de tratamiento
              </h6>
              <small v-if="planningOrder.model_3d_url">
                <b-button
                  variant="link"
                  size="sm"
                  @click="viewDocument(planningOrder.model_3d_url, 'Plan de tratamiento', 'embedded')"
                >Ver Plan de tratamiento</b-button>
              </small>
            </b-media-body>

            <div v-if="[1, 3].includes(userData.role.id)">
              <b-button
                v-if="!planningOrder.model_3d_url"
                variant="info"
                class="float-right"
                size="sm"
                @click="uploadDataPlanning('model_3d_url')"
              >
                Editar / Agregar
              </b-button>
              <b-button
                v-else
                variant="danger"
                class="float-right"
                size="sm"
                @click="confirmDelete('model_3d_url')"
              >
                Eliminar
              </b-button>
            </div>

          </b-media>

          <b-media
            v-if="userData.role_id != 3"
            class="mb-2"
            no-body
          >
            <b-media-aside class="mr-1">
              <b-avatar
                rounded
                :variant="planningOrder.total_cost ? 'light-primary' : 'light-secondary'"
                size="34"
              >
                <feather-icon
                  icon="DollarSignIcon"
                  size="18"
                />
              </b-avatar>
            </b-media-aside>

            <b-media-body>
              <h6 class="mb-0">
                Costos
              </h6>

              <small>
                {{ formatCurrency(planningOrder.total_cost) }}
              </small>
            </b-media-body>

            <!--<div v-if="[1, 3, 5].includes(userData.role.id) && !planningOrder.is_paid">
              <b-button
                v-if="planningOrder.total_cost"
                variant="success"
                class="float-right"
                size="sm"
                :to="{ name: 'admin-checkout', params: { id: planningOrder.id, payment_type: 'planificacion' } }"
              >
                Ver detalle / Pagar
              </b-button>
            </div> -->

            <div v-if="planningOrder.is_paid">
              <b-badge variant="light-success">
                <feather-icon
                  icon="CheckIcon"
                  size="18"
                />
                Pago realizado
              </b-badge>
            </div>
            <div v-else>
              <b-badge variant="light-warning">
                <feather-icon
                  icon="AlertTriangleIcon"
                  size="18"
                />
                Pago pendiente
              </b-badge>
            </div>

          </b-media>
        </div>

        <div
          v-else
          class="mt-2"
        >

          <b-alert
            variant="info"
            show
          >
            <h4 class="alert-heading">
              Aún no se ha realizado el pago de la planificación.
            </h4>
            <div class="alert-body">
              <p>Para poder continuar con el proceso, es necesario completar el pago.</p>

              <b-button
                v-if="[1, 2].includes(userData.role.id)"
                variant="success"
                class="mt-1"
                size="sm"
                @click="paymentModal = true"
              >Registrar pago</b-button>
            </div>

          </b-alert>

          <hr class="mb-2">

        </div>

        <b-row>
          <b-col
            cols="12"
            lg="12"
          >
            <b-alert
              variant="secondary"
              show
            >
              <h4 class="alert-heading">
                Observaciones
              </h4>
              <div class="alert-body">
                <span>{{ planningOrder.observation ? planningOrder.observation : 'Sin observaciones' }}</span>
              </div>
            </b-alert>

            <div v-if="[1, 3].includes(userData.role.id)">
              <b-button
                variant="info"
                class="float-right"
                size="sm"
                @click="uploadDataPlanning('observation')"
              >
                Agregar observación
              </b-button>
            </div>

          </b-col>
        </b-row>

      </b-card-body>

    </b-card>

    <!-- modal management-->

    <b-modal
      v-model="managementModal"
      cancel-variant="outline-secondary"
      ok-title="Guardar"
      cancel-title="Cancelar"
      centered
      title="Gestionar planificación"
      @ok.prevent="submitForm"
    >
      <validation-observer ref="simpleRules">
        <b-form>
          <b-form-group
            v-if="typeUpload === 'planning_pdf'"
            label="Planificación PDF"
          >
            <validation-provider
              #default="{ errors }"
              name="Planificación PDF"
              rules="required"
            >
              <b-form-file
                v-model="form.planning_pdf"
                accept=".pdf"
                :state="errors.length > 0 ? false : null"
                browse-text="Adjuntar"
                @change="onFileChange($event, 'planning_pdf')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

          </b-form-group>

          <b-form-group
            v-if="typeUpload === 'models'"
            label="Modelos (.zip)"
          >
            <validation-provider
              #default="{ errors }"
              name="Modelos (.zip)"
              rules="required"
            >
              <b-form-file
                v-model="form.models"
                accept=".zip"
                :state="errors.length > 0 ? false : null"
                browse-text="Adjuntar"
                @change="onFileChange($event, 'models')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

          </b-form-group>

          <b-form-group
            v-if="typeUpload === 'model_3d_url'"
            label="Modelo 3D (URL)"
          >
            <validation-provider
              #default="{ errors }"
              name="Modelo 3D (URL)"
              rules="required"
            >
              <b-form-input
                v-model="form.model_3d_url"
                type="url"
                placeholder="https://example.com/model"
                :state="errors.length > 0 ? false : null"
                browse-text="Adjuntar"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

          </b-form-group>

          <b-form-group
            v-if="typeUpload === 'observation'"
            label="Observaciones"
          >
            <validation-provider
              #default="{ errors }"
              name="Observaciones"
              rules="required"
            >
              <b-form-textarea
                v-model="form.observation"
                placeholder="Escribe tus observaciones aquí..."
                rows="4"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

          </b-form-group>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
      v-model="viewImageModal"
      cancel-variant="outline-danger"
      ok-only
      ok-title="Cerrar"
      centered
      :title="title"
      size="lg"
    >
      <b-card>
        <b-img
          :src="urlDocument"
          fluid
        />
      </b-card>
    </b-modal>

    <b-modal
      v-model="viewCarrouselModal"
      cancel-variant="outline-danger"
      ok-only
      ok-title="Cerrar"
      centered
      :title="title"
      size="lg"
    >

      <p>Cantidad de archivos: {{ imagesCarrousel.filter(img => img.type === type).length }}</p>

      <b-card>

        <b-carousel
          v-if="imagesCarrousel.length"
          :interval="0"
          controls
          indicators
          background="#fff"
          img-width="500"
          img-height="500"
          style="text-align: center;"
        >
          <b-carousel-slide
            v-for="(image, index) in imagesCarrousel.filter(img => img.type === type)"
            :key="index"
          >
            <template #img>
              <b-img
                v-if="isImage(image.full_url)"
                :src="image.full_url"
                class="d-block mx-auto img-fit"
                alt="Imagen RX"
                fluid
              />
              <iframe
                v-else
                :src="image.full_url"
                width="100%"
                height="600px"
                style="border: none;"
              />
            </template>
          </b-carousel-slide>

        </b-carousel>
        <div
          v-else
          class="text-center text-muted py-5"
        >
          No hay imágenes disponibles.
        </div>
      </b-card>
    </b-modal>

    <b-modal
      v-model="viewPdfModal"
      cancel-variant="outline-danger"
      ok-only
      ok-title="Cerrar"
      centered
      :title="title"
      size="lg"
    >
      <b-card>
        <iframe
          :src="urlDocument"
          width="100%"
          height="600px"
          style="border: none;"
        />
      </b-card>
    </b-modal>

    <b-modal
      v-model="viewModelModal"
      cancel-variant="outline-danger"
      ok-only
      ok-title="Cerrar"
      centered
      size="xl"
      :title="title"
    >
      <b-card>
        <iframe
          :src="urlDocument"
          width="100%"
          height="500"
          frameborder="0"
          allowfullscreen
          class="mb-4"
        />

        <a
          :href="urlDocument"
          target="_blank"
        >Puedes verlo también aqui</a>

      </b-card>
    </b-modal>

    <!-- modal para agregar registro de pago -->
    <b-modal
      v-model="paymentModal"
      cancel-variant="outline-secondary"
      ok-title="Guardar"
      cancel-title="Cancelar"
      centered
      title="Registrar pago"
      @ok.prevent="submitPayment"
    >
      <p>Valor a cancelar: {{ formatCurrency(planningOrder.total_cost) }}</p>
      <p>Por favor, valida cuidadosamente la información del soporte o registro que vas a adjuntar antes de continuar con el proceso.</p>
      <validation-observer ref="paymentSupportRules">
        <b-form>
          <b-form-group label="Medio de pago">
            <validation-provider
              #default="{ errors }"
              name="Medio de pago"
              rules="required"
            >
              <b-form-select
                v-model="paymentForm.payment_method_id"
                :state="errors.length > 0 ? false : null"
                :options="paymentMethods"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
            v-if="paymentForm.payment_method_id === 1"
            label="Soporte de pago"
          >
            <validation-provider
              #default="{ errors }"
              name="Soporte de pago"
              rules="required"
            >
              <b-form-file
                v-model="paymentForm.payment_support"
                :state="errors.length > 0 ? false : null"
                browse-text="Adjuntar"
                @change="onpaymentSupportChange"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

          </b-form-group>

        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BTable,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BFormCheckbox,
  BMediaAside,
  BMedia,
  BAvatar,
  BMediaBody,
  BButton,
  BRow,
  BCol,
  BAlert,
  BForm,
  BModal,
  BFormTextarea,
  BFormGroup,
  BFormFile,
  BFormInput,
  BImg,
  BBadge,
  BCarousel,
  BCarouselSlide,
  BFormSelect,
} from 'bootstrap-vue'
import api from '@/plugin/axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import planningOrders from '@/views/admin/planning-orders/PlanningOrders.vue'
import { includes } from 'core-js/internals/array-includes'
import { formatCurrency } from '@/helpers/utils'

export default {
  components: {
    BFormSelect,
    BBadge,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormTextarea,
    BModal,
    BForm,
    BRow,
    BCol,
    BAlert,
    BButton,
    BMediaBody,
    BAvatar,
    BMedia,
    BMediaAside,
    BCard,
    BTable,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BFormCheckbox,
    BFormFile,
    BFormInput,
    BImg,
    BCarousel,
    BCarouselSlide,
  },
  props: {
    planningOrder: {
      type: Object,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        planning_pdf: null,
        models: null,
        model_3d_url: '',
        observation: '',
      },
      paymentForm: {
        payment_method_id: null,
        payment_support: null,
      },
      managementModal: false,
      deleteModal: false,
      viewImageModal: false,
      viewCarrouselModal: false,
      viewPdfModal: false,
      viewModelModal: false,
      paymentModal: false,
      urlDocument: '',
      title: '',
      type: '',
      typeUpload: '',
      imagesCarrousel: [],
      paymentSupport: null,
      paymentMethods: [
        { value: 1, text: 'Transferencia' },
        { value: 2, text: 'Crédito' },
      ],
    }
  },
  setup() {
  },
  computed: {
  },
  methods: {
    formatCurrency,
    includes,
    isImage(url) {
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(url)
    },
    viewDocument(urlDocument, title, type) {
      this.urlDocument = urlDocument
      this.title = title
      this.type = type

      if (type === 'image') {
        this.viewImageModal = true
      } else if (type === 'rx_panorama' || type === 'intraoral_photos') {
        this.imagesCarrousel = urlDocument
        this.viewCarrouselModal = true
      } else if (type === 'pdf') {
        this.viewPdfModal = true
      } else if (type === 'embedded') {
        this.viewModelModal = true
      } else {
        // DOWNLOAD
        const fileUrl = urlDocument // Cambia esto por tu URL
        const link = document.createElement('a')
        link.href = fileUrl
        link.setAttribute('download', `${this.planningOrder.id}_${title}.zip`) // Nombre del archivo al descargar
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    uploadDataPlanning(typeUpload) {
      console.log(typeUpload)
      this.typeUpload = typeUpload
      this.managementModal = true
    },
    onFileChange(event, field) {
      this.form[field] = event.target.files[0]
      // console.log(this.form[field])
    },
    submitForm() {
      const formData = new FormData()
      // eslint-disable-next-line guard-for-in
      for (const key in this.form) {
        const value = this.form[key]

        // Solo agregamos si el valor no es null, vacío o "null" como string
        if (value !== null && value !== undefined && value !== 'null' && value !== '') {
          formData.append(key, value)
        }
      }

      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          try {
            const response = await api.post(`/api/planning-orders/${this.planningOrder.id}`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            this.$bvToast.toast('Se ha actualizado la planificación del pedido con éxito', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })
            this.$router.go(0)
          } catch (error) {
            console.log('loading', error)
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
            this.managementModal = false
            this.form.planning_pdf = null
            this.form.models = null
            this.form.model_3d_url = ''
            this.form.observation = ''
          }
        }
      }).catch(err => {
        this.loading = false
        console.log('finally', this.order, err)

        const { errors } = this.$refs.simpleRules

        console.log('Errores:', errors)

        // Si quieres ver qué campo tiene el error
        for (const error of errors) {
          console.log(`Campo: ${error.field}, Error: ${error.msg}`)
        }
      })
    },
    onpaymentSupportChange(event) {
      [this.paymentSupport] = event.target.files
    },
    submitPayment() {
      const formData = new FormData()
      formData.append('payment_support', this.paymentSupport) // nombre esperado por tu backend
      formData.append('payment_method_id', this.paymentForm.payment_method_id)
      formData.append('payment_type', 'planificacion')

      this.$refs.paymentSupportRules.validate().then(async success => {
        if (success) {
          try {
            await api.post(`/api/payments/payment-support/${this.planningOrder.id}`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            this.$bvToast.toast('Se ha actualizado el pago', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })
            this.$router.go(0)
          } catch (error) {
            // console.log('loading', error)
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
            this.managementModal = false
            this.form.planning_pdf = null
            this.form.models = null
            this.form.model_3d_url = ''
            this.form.observation = ''
          }
        }
      }).catch(err => {
        this.loading = false
        console.log('finally', this.order, err)
        const { errors } = this.$refs.simpleRules

        console.log('Errores:', errors)

        // Si quieres ver qué campo tiene el error
        for (const error of errors) {
          console.log(`Campo: ${error.field}, Error: ${error.msg}`)
        }
      })
    },
    async confirmDelete(type) {
      const confirmDelete = confirm('¿Estás seguro de que deseas eliminar este dato?')

      if (confirmDelete) {
        await this.deleteData(type)
      }
    },
    async deleteData(type) {
      try {
        const formData = new FormData()
        formData.append(type, 1)

        const response = await api.post(`/api/planning-orders/delete-data/${this.planningOrder.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        if (response.status === 200) {
          this.$bvToast.toast('Se ha eliminado correctamente.', {
            title: '¡Eliminado!', // Título del toast
            variant: 'success', // Color del toast
            solid: true, // Hace que el toast no sea translúcido
            autoHideDelay: 5000, // Duración en milisegundos (opcional)
            appendToast: true, // Asegura que se muestre como el más reciente
          })
          this.$router.go(0)
        }
      } catch (error) {
        console.error('Error eliminando el dato:', error)
        alert('Hubo un error eliminando el dato.')
      }
    },
  },
}
</script>

<style>
.carousel-control-prev,
.carousel-control-next {
  background-color: rgba(0, 0, 0, 0.4); /* Fondo oscuro semitransparente */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  top: 50%;
  transform: translateY(-50%);
}

.img-fit {
  max-height: 70vh; /* ajusta según tu necesidad */
  object-fit: contain;
}
</style>
